export const RM_PERMISSION_MODULE = 'RepairAndMaintenance';

/**
 * Frontend permission keys used in Repair & Maintenance UI.
 * Match BE actionPermissions.action names from /my → companyPermissions.
 */
export const RmAction = {
  Create: 'Create',
  View: 'View',
  Update: 'Update',
  UpdateDraft: 'UpdateDraft',
  DeleteDraft: 'DeleteDraft',
  Withdraw: 'Withdraw',
  Submit: 'Submit',
  Comment: 'Comment',
  Return: 'Return',
  Reject: 'Reject',
  Approve: 'Approve',
  ReferToCompanyAdmin: 'ReferToCompanyAdmin',
  /** @deprecated Prefer InviteVendor — kept for existing call sites */
  AssignVendor: 'AssignVendor',
  InviteVendor: 'InviteVendor',
  ExternalInviteVendor: 'ExternalInviteVendor',
  VendorInviteRevoke: 'VendorInviteRevoke',
  StartWork: 'StartWork',
  CompleteWork: 'CompleteWork',
  AddQuotation: 'AddQuotation',
  EditQuotation: 'EditQuotation',
  ApproveQuotation: 'ApproveQuotation',
  RejectQuotation: 'RejectQuotation',
  QuotationItemApproval: 'QuotationItemApproval',
  QuotationItemRejection: 'QuotationItemRejection',
  SubmitQuotation: 'SubmitQuotation',
  SubmitInvoice: 'SubmitInvoice',
  EditInvoice: 'EditInvoice',
  ApproveInvoice: 'ApproveInvoice',
  RejectInvoice: 'RejectInvoice',
  InvoiceItemApproval: 'InvoiceItemApproval',
  InvoiceItemRejection: 'InvoiceItemRejection',
  IntegrateToAP: 'IntegrateToAP',
  CreateApprovalProcess: 'CreateApprovalProcess',
  UpdateApprovalProcess: 'UpdateApprovalProcess',
  DeleteApprovalProcess: 'DeleteApprovalProcess',
} as const;

export type RmActionName = (typeof RmAction)[keyof typeof RmAction];

/** Raw action names returned by /my → companyPermissions.actionPermissions */
export const RmBackendAction = {
  Create: 'Create',
  CreateDraft: 'CreateDraft',
  View: 'View',
  Update: 'Update',
  UpdateDraft: 'UpdateDraft',
  DeleteDraft: 'DeleteDraft',
  Withdraw: 'Withdraw',
  Submit: 'Submit',
  Comment: 'Comment',
  Return: 'Return',
  Reject: 'Reject',
  Approve: 'Approve',
  Refer: 'Refer',
  ReferToCompanyAdmin: 'ReferToCompanyAdmin',
  AssignVendor: 'AssignVendor',
  InviteVendor: 'InviteVendor',
  ExternalInviteVendor: 'ExternalInviteVendor',
  VendorInviteRevoke: 'VendorInviteRevoke',
  StartWork: 'StartWork',
  CompleteWork: 'CompleteWork',
  AddQuotation: 'AddQuotation',
  EditQuotation: 'EditQuotation',
  ApproveQuotation: 'ApproveQuotation',
  RejectQuotation: 'RejectQuotation',
  QuotationItemApproval: 'QuotationItemApproval',
  QuotationItemRejection: 'QuotationItemRejection',
  SubmitQuotation: 'SubmitQuotation',
  SubmitInvoice: 'SubmitInvoice',
  EditInvoice: 'EditInvoice',
  ApproveInvoice: 'ApproveInvoice',
  RejectInvoice: 'RejectInvoice',
  InvoiceItemApproval: 'InvoiceItemApproval',
  InvoiceItemRejection: 'InvoiceItemRejection',
  IntegrateToAP: 'IntegrateToAP',
  CreateApprovalProcess: 'CreateApprovalProcess',
  UpdateApprovalProcess: 'UpdateApprovalProcess',
  DeleteApprovalProcess: 'DeleteApprovalProcess',
} as const;
